// extracted by mini-css-extract-plugin
module.exports = {"root":"Standards_root__3Ery9","top":"Standards_top__1-LJe","details":"Standards_details__2QDCv","row":"Standards_row__39IdD","students":"Standards_students__2BP-G"};